import { FC } from 'react';

import { classNames } from '@/utils/classNames';

import usePlankTableStore from '../../hooks/usePlankTableStore';
import { Reserve } from '../../types';
import { geefReserveToelichtingNotitieMarge } from '../../utils/reserve';
import NotitieRelatedItem from '../Notitie/NotitieRelatedItem';

import ReserveDefectIcon from './ReserveDefectIcon';
import ReserveToelichting from './ReserveToelichting';

import plankStyles from '../../PlankView.module.css';
import tableStyles from '../Table/Table.module.css';
import reserveStyles from './Reserve.module.css';

/** Renders a single list row for Conflict, Reserve and related types.
 *
 * @param props
 * @returns
 */
const ReserveSidepanel: FC<{ reserve: Reserve }> = ({ reserve }) => {
  const relatedDefect = usePlankTableStore((state) => state.getRelatedDefect(String(reserve.eenheid)));
  const relatedNotitie = usePlankTableStore((state) => state.getReserveNotitie(reserve));
  const notitieMarge = geefReserveToelichtingNotitieMarge(
    Boolean(relatedNotitie?.status),
    Boolean(relatedNotitie?.opmerking),
  );

  return (
    <div className={tableStyles.cardStyleSidepanel}>
      <div className={reserveStyles.spReserveDivStyle}>
        <div className={reserveStyles.tableListItemStyle}>
          <div className={plankStyles.eenheidStyle}>{reserve.eenheid}</div>
          <div className={plankStyles.drglpStyle}>{reserve.dienstregelpunt.toLocaleLowerCase()}</div>
          <ReserveDefectIcon reserve={reserve} relatedDefect={relatedDefect} metSidepanelToggle />
        </div>
        <ReserveToelichting
          reserve={reserve}
          className={classNames(
            notitieMarge === 'status' && reserveStyles.reserveToelichtingWithNotitieStatusStyle,
            notitieMarge === 'icoon' && reserveStyles.reserveToelichtingWithNotitieIconStyle,
            notitieMarge === 'beide' && reserveStyles.reserveToelichtingWithNotitieBeideStyle,
          )}
        />
      </div>
      <NotitieRelatedItem notitie={relatedNotitie} />
    </div>
  );
};
export default ReserveSidepanel;
